import React, { useState, useEffect } from "react";
import Sidebar, { SIDEBAR_WIDTH } from "../components/Sidebar";
import Topbar from "../components/Topbar";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Auction from "../pages/Auction";
import ChatDock from "../components/chat/ChatDock";
import SpotlightTour from "../components/onboarding/SpotlightTour";
import { useAuth } from "../context/AuthContext";
import "./layout.css";

function DashboardLayout() {
  const { user } = useAuth();
  const [sidebarWidth, setSidebarWidth] = useState(SIDEBAR_WIDTH);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);
  const isTourRequested = searchParams.get("tour") === "true";
  const [runTour, setRunTour] = useState(isTourRequested);

  useEffect(() => {
    const isTour = new URLSearchParams(location.search).get("tour") === "true";
    if (isTour) {
      setRunTour(true);
    }
  }, [location.search]);

  const handleTourComplete = () => {
    setRunTour(false);
    navigate(location.pathname, { replace: true });
  };

  const isAuction = location.pathname.startsWith("/dashboard/auction");

  return (
    <div className="crm-shell">
      <Sidebar 
        onWidthChange={setSidebarWidth} 
        mobileOpen={mobileOpen} 
        onCloseMobile={() => setMobileOpen(false)} 
      />

      <div className="crm-main" style={{ marginLeft: sidebarWidth }}>
        <Topbar onToggleMobileSidebar={() => setMobileOpen((prev) => !prev)} />
        <div className={`crm-main-body ${isAuction ? "is-auction-active" : ""}`}>
          <div style={{ display: isAuction ? "none" : "block", height: "100%" }}>
            <Outlet />
          </div>
          <div style={{ display: isAuction ? "block" : "none", height: "100%" }}>
            <Auction />
          </div>
        </div>
      </div>

      {/* Persistent Team Chat, PlatinumBot & Buddy Assistant Dock */}
      <ChatDock />

      {/* Real In-App Guided Tour (Seamlessly mounted across all routes) */}
      {runTour && (
        <SpotlightTour
          role={user?.role || "Agent"}
          onComplete={handleTourComplete}
        />
      )}
    </div>
  );
}

export default DashboardLayout;
